/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Monthly_BilledInputs */

const tr_pricing_monthly_billed = /** @type {(inputs: Pricing_Monthly_BilledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aylık faturalandırılır`)
};

const en_pricing_monthly_billed = /** @type {(inputs: Pricing_Monthly_BilledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billed monthly`)
};

const de_pricing_monthly_billed = /** @type {(inputs: Pricing_Monthly_BilledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatliche Abrechnung`)
};

const ru_pricing_monthly_billed = /** @type {(inputs: Pricing_Monthly_BilledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежемесячная оплата`)
};

/**
* | output |
* | --- |
* | "Billed monthly" |
*
* @param {Pricing_Monthly_BilledInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_monthly_billed = /** @type {((inputs?: Pricing_Monthly_BilledInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Monthly_BilledInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_monthly_billed(inputs)
	if (locale === "de") return de_pricing_monthly_billed(inputs)
	if (locale === "ru") return ru_pricing_monthly_billed(inputs)
	return tr_pricing_monthly_billed(inputs)
});